<template>
    <div class="login-container">
        <!-- 主内容卡片 -->
        <div class="main-card">
            <!-- 左侧内容区域 -->
            <div class="left-content">
                <!-- Logo占位符 -->
                <div class="logo-placeholder">
                    <span class="logo-text">{{ companyName }}</span>
                </div>

                <!-- 宣传文字 -->
                <div class="slogan-text">
                    <p>诚信为发展之本，筑牢专业评审之基。</p>
                    <p>信息化夯实底座，赋能科学高效管理。</p>
                    <p>系统贯全周期，实现标准化服务保障。</p>
                    <p>数字赋能专家资源，构建精准专业画像。</p>
                    <p>多维评估为依据，公正量化能力绩效。</p>
                    <p>规范覆盖各节点，实现过程可溯可查。</p>
                    <p>评审标准化运营，构建公正权威生态。</p>
                </div>
            </div>

            <!-- 右侧登录卡片 -->
            <div class="login-card">
                <div class="card-header">
                    <h2 class="card-title">评标专家库注册</h2>
                </div>

                <div class="login-form">
                    <div class="form-item">
                        <input type="text" v-model="loginForm.expertName" placeholder="专家姓名" class="form-input" />
                    </div>
                    <div class="form-item">
                        <input type="text" v-model="loginForm.idCard" placeholder="身份证号" class="form-input" />
                    </div>
                    <div class="form-item">
                        <input type="text" v-model="loginForm.phone" placeholder="手机号" class="form-input" />
                    </div>
                    <div class="form-item captcha-row">
                        <input type="text" v-model="loginForm.captchaCode" placeholder="手机验证码"
                            class="form-input captcha-input" />
                        <div class="captcha-placeholder" @click="sendSmsCode" :class="{ disabled: countdown > 0 }">
                            <span v-if="countdown === 0">获取验证码</span>
                            <span v-else>{{ countdown }}s后重新获取</span>
                        </div>
                    </div>
                    <!-- <div class="form-item">
                        <input type="password" v-model="loginForm.loginPassword" placeholder="登录密码"
                            class="form-input" />
                    </div>
                    <div class="form-item">
                        <input type="password" v-model="loginForm.confirmPassword" placeholder="确认密码"
                            class="form-input" />
                    </div>
                    <div class="form-item">
                        <input type="password" v-model="loginForm.sealPassword" placeholder="签章密码" class="form-input" />
                    </div> -->
                    <div class="form-item">
                        <el-checkbox v-model="loginForm.checked">已阅读须知</el-checkbox>
                    </div>
                    <button class="login-btn" @click="handleRegister">确认注册</button>
                    <div class="register-link">已经注册，请 <span class="link-text" @click="handleLogin">登录</span>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { register, sendSmsCode } from '@/api/modules/expertBank'
export default {
    name: 'ExpertLogin',
    data() {
        return {
            loginForm: {
                expertName: '',        // 专家姓名
                idCard: '',           // 身份证号
                phone: '',            // 手机号码
                captchaCode: '',      // 短信验证码
                captchaCodeUuid: '',   //验证码UUID
                loginPassword: '',    // 登录密码
                confirmPassword: '', // 确认密码
                sealPassword: '',     // 签章密码
                checked: true
            },
            countdown: 0,             // 倒计时秒数
            timer: null               // 定时器
        }
    },
    computed: {
        companyName() {
            return this.$channelMaterial.getCompanyName()
        },
          channelCode() {
            return this.$channelMaterial.getChannelCode()
        },
    },
    methods: {
        // 注册逻辑
        async handleRegister() {
            // 表单验证
            if (!this.validateForm()) {
                return;
            }
            try {
                const registerData = {
                    expertName: this.loginForm.expertName,
                    idCard: this.loginForm.idCard,
                    phone: this.loginForm.phone,
                    captchaCode: this.loginForm.captchaCode,
                    loginPassword: this.loginForm.loginPassword,
                    sealPassword: this.loginForm.sealPassword,
                    captchaCodeUuid: this.loginForm.captchaCodeUuid,
                    channelCode:this.channelCode
                };
                const res = await register(registerData);
                if (res.code === 200) {
                    if (res.data.caRegisterStatus == 0) {
                        this.$message.success('注册成功');
                        this.$router.push('/expertBankLogin');
                        setTimeout(() => {
                            window.open(res.data.caRegisterUrl, '_blank');
                        }, 1000);
                    } else {
                        this.$message.success('注册成功');
                        this.$router.push('/expertBankLogin');
                    }
                } else {
                    this.$message.error(res.msg || '注册失败');
                }
            } catch (error) {
                console.error('注册失败:', error);
                this.$message.error('网络异常，请稍后重试');
            }
        },
        // 发送验证码逻辑
        sendSmsCode() {
            // 如果正在倒计时，不允许重复发送
            if (this.countdown > 0) {
                return;
            }

            // 验证手机号
            if (!this.loginForm.phone.trim()) {
                this.$message.error('请先输入手机号');
                return;
            }

            const phoneReg = /^1[3-9]\d{9}$/;
            if (!phoneReg.test(this.loginForm.phone)) {
                this.$message.error('请输入正确的手机号');
                return;
            }
            sendSmsCode({ phone: this.loginForm.phone }).then(res => {
                if (res.code === 200) {
                    this.$message.success('验证码发送成功');
                    this.startCountdown();
                    this.loginForm.captchaCodeUuid = res.data.uuid;
                } else {
                    this.$message.error(res.msg || '获取验证码失败')
                }
            }).catch(error => {
                this.$message.error('获取验证码失败，请重试')
                console.error('获取验证码失败:', error)
            })

        },

        // 表单验证
        validateForm() {
            const { expertName, idCard, phone, captchaCode, loginPassword, confirmPassword, sealPassword, checked } = this.loginForm;
            if (!expertName.trim()) {
                this.$message.error('请输入专家姓名');
                return false;
            }
            if (!idCard.trim()) {
                this.$message.error('请输入身份证号');
                return false;
            }
            // 身份证号格式验证
            const idCardReg = /(^\d{15}$)|(^\d{18}$)|(^\d{17}(\d|X|x)$)/;
            if (!idCardReg.test(idCard)) {
                this.$message.error('请输入正确的身份证号');
                return false;
            }
            if (!phone.trim()) {
                this.$message.error('请输入手机号');
                return false;
            }
            // 手机号格式验证
            const phoneReg = /^1[3-9]\d{9}$/;
            if (!phoneReg.test(phone)) {
                this.$message.error('请输入正确的手机号');
                return false;
            }
            if (!captchaCode.trim()) {
                this.$message.error('请输入短信验证码');
                return false;
            }
            // if (!loginPassword.trim()) {
            //     this.$message.error('请输入登录密码');
            //     return false;
            // }
            // if (loginPassword.length < 6) {
            //     this.$message.error('登录密码不能少于6位');
            //     return false;
            // }
            // if (!confirmPassword.trim()) {
            //     this.$message.error('请输入确认密码');
            //     return false;
            // }
            // if (loginPassword !== confirmPassword) {
            //     this.$message.error('两次输入的密码不一致');
            //     return false;
            // }
            // if (!sealPassword.trim()) {
            //     this.$message.error('请输入签章密码');
            //     return false;
            // }

            // if (sealPassword.length < 6) {
            //     this.$message.error('签章密码不能少于6位');
            //     return false;
            // }

            if (!checked) {
                this.$message.error('请先阅读并同意注册须知');
                return false;
            }

            return true;
        },

        // 开始倒计时
        startCountdown() {
            this.countdown = 60;
            this.timer = setInterval(() => {
                this.countdown--;
                if (this.countdown <= 0) {
                    this.clearCountdown();
                }
            }, 1000);
        },

        // 清除倒计时
        clearCountdown() {
            if (this.timer) {
                clearInterval(this.timer);
                this.timer = null;
            }
            this.countdown = 0;
        },

        // 跳转到登录页面
        handleLogin() {
            this.$router.push('/expertBankLogin');
        }
    },

    // 组件销毁时清除定时器
    beforeDestroy() {
        this.clearCountdown();
    }
}
</script>

<style lang="less" scoped>
.login-container {
    min-height: 100vh;
    background: linear-gradient(135deg, #4A90E2 0%, #357ABD 50%, #2E5B8A 100%);
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 20px;
    position: relative;

    &::before {
        content: '';
        position: absolute;
        bottom: 0;
        left: 0;
        right: 0;
        height: 200px;
        background: linear-gradient(to top, rgba(255, 255, 255, 0.1) 0%, transparent 100%);
        pointer-events: none;
    }
}

.main-card {
    border-radius: 12px;
    box-shadow: 0 8px 32px rgba(0, 0, 0, 0.15);
    display: flex;
    overflow: hidden;
    min-height: 480px;
}

.left-content {
    width: 400px;
    background: linear-gradient(135deg, #4A90E2 0%, #357ABD 50%, #2E5B8A 100%);
    color: white;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    position: relative;
}

.logo-placeholder {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    height: 60px;
    display: flex;
    align-items: center;
    justify-content: center;

    .logo-text {
        color: white;
        font-size: 18px;
        font-weight: bold;
    }
}

.slogan-text {
    font-size: 16px;
    line-height: 2;

    p {
        margin: 0 0 8px 0;
        opacity: 0.95;
    }
}

.login-card {
    background: white;
    padding: 40px;
    width: 400px;
    display: flex;
    flex-direction: column;
    justify-content: center;
}

.card-header {
    text-align: center;
    margin-bottom: 40px;
}

.card-title {
    font-size: 20px;
    color: #333;
    margin: 0;
    font-weight: 500;
}

.login-form {
    .form-item {
        margin-bottom: 20px;

        &.captcha-row {
            display: flex;
        }
    }

    .form-input {
        width: 100%;
        height: 48px;
        border: 1px solid #e0e0e0;
        border-radius: 6px;
        padding: 0 16px;
        font-size: 14px;
        outline: none;
        transition: border-color 0.3s;

        &:focus {
            border-color: #4A90E2;
        }

        &::placeholder {
            color: #999;
        }

        &.captcha-input {
            flex: 1;
        }
    }

    .captcha-placeholder {
        width: 100px;
        height: 48px;
        background-color: #4A90E2;
        display: flex;
        align-items: center;
        justify-content: center;
        color: white;
        font-size: 12px;
        cursor: pointer;
        border-radius: 5px;
        transition: background-color 0.3s ease;

        &:hover {
            background-color: #357ABD;
        }

        &.disabled {
            background-color: #ccc;
            cursor: not-allowed;

            &:hover {
                background-color: #ccc;
            }
        }
    }



    .forgot-link {
        color: #4A90E2;
        font-size: 14px;
        cursor: pointer;
        text-decoration: none;

        &:hover {
            text-decoration: underline;
        }
    }

    .login-btn {
        width: 100%;
        height: 48px;
        background: #4A90E2;
        color: white;
        border: none;
        border-radius: 6px;
        font-size: 16px;
        font-weight: 500;
        cursor: pointer;
        transition: background-color 0.3s;
        margin-bottom: 20px;

        &:hover {
            background: #357ABD;
        }

        &:active {
            background: #2E5B8A;
        }
    }

    .register-link {
        text-align: center;
        font-size: 14px;
        color: #666;

        .link-text {
            color: #ff4444;
            cursor: pointer;
            text-decoration: none;

            &:hover {
                text-decoration: underline;
            }
        }
    }
}

@media (max-width: 768px) {
    .login-container {
        flex-direction: column;
        padding: 20px;
    }

    .left-content {
        margin-right: 0;
        margin-bottom: 40px;
        text-align: center;
        max-width: 100%;
    }

    .login-card {
        width: 100%;
        max-width: 400px;
        padding: 30px 20px;
    }
}
</style>